<template>
  <div class="wlx-basic-info-wrapper">
    <BasicInfo v-if="tabName=='first'"></BasicInfo>
    <!-- <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <BasicInfo v-if="tabName=='first'"></BasicInfo>
      </el-tab-pane>
      <el-tab-pane label="密码管理" name="second">
        <PassWordEdit v-if="tabName=='second'"></PassWordEdit>
      </el-tab-pane>
      <el-tab-pane label="手机号更改" name="phone">
        <phoneNumber v-if="tabName == 'phone'"></phoneNumber>
      </el-tab-pane>
      <el-tab-pane label="精彩之窗" name="banner">
        <BannerManger v-if="tabName == 'banner'" :type="2"></BannerManger>
      </el-tab-pane>
      <el-tab-pane label="考试端地址" name="third">
        <FileManager v-if="tabName == 'third'"></FileManager>
      </el-tab-pane>
      <el-tab-pane label="考试信息管理" name="four">
        <examInfoManager v-if="tabName == 'four'"></examInfoManager>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>
 
<script>
import { MU_UPATE_AUTH } from "store/index";
import BasicInfo from "page/xSchool/manager/BasicInfo.vue";
import PassWordEdit from "page/xSchool/manager/PassWordEdit.vue";
import phoneNumber from "page/xSchool/manager/phoneNumber.vue";
import BannerManger from "page/xSchool/manager/BannerManger.vue";
import FileManager from "page/xSchool/56xSystemManager/uploadFileManager.vue";
import examInfoManager from "page/xSchool/56xSystemManager/examInfoManager.vue";
export default {
  data() {
    return {
      tabName: "first"
    };
  },
  components: {
    BasicInfo,
    PassWordEdit,
    phoneNumber,
    BannerManger,
    FileManager,
    examInfoManager
  },
  created() {
    // var that = this;
    // if (localStorage["userId"] !== undefined) {
    //   that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    // }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.wlx-basic-info-wrapper {
  .el-tabs__header {
    position: fixed;
    top: 60px;
    right: 0;
    height: 60px;
    width: calc(100% - 240px);
    z-index: 1000;
    background: #fff;
    text-align: right;
  }
  .el-tabs__item {
    width: 120px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .el-tabs__content {
    margin: 80px 0 0 30px;
    background: #fff;
    .el-tab-pane {
      padding: 20px;
    }
  }
}
</style>
